import { useEffect, useState } from "react";
import { Copy, CalendarSync, RefreshCw, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";

const GOOGLE_ADD = "https://calendar.google.com/calendar/u/0/r/settings/addbyurl";

export const CalendarFeed = () => {
  const [f, setF] = useState(null);
  const [steps, setSteps] = useState(false);
  const wrap = (d) => { const url = `${process.env.REACT_APP_BACKEND_URL}${d.path}`; return { url, webcal: url.replace(/^https?:\/\//, "webcal://") }; };
  useEffect(() => { http.get("/conferences/feed-link").then((r) => setF(wrap(r.data))).catch(() => {}); }, []); // eslint-disable-line
  if (!f) return null;
  const copy = () => { navigator.clipboard?.writeText(f.url); toast.success("Calendar link copied"); };
  const reset = async () => {
    if (!window.confirm("Make a new link? The old link will stop working, and you'll need to add the new one to your calendar again.")) return;
    try { setF(wrap((await http.post("/conferences/feed-link/reset")).data)); toast.success("New calendar link made"); } catch (e) { toast.error(formatApiError(e)); }
  };
  const btn = "inline-flex items-center gap-1.5 px-3 py-2 rounded-full border border-[#E6DEC3] bg-white text-xs text-[#2C4A3E] hover:bg-[#F1EADB]";
  return (
    <section className="rounded-2xl bg-[#EEF3EF] p-4 space-y-3 min-w-0 w-full overflow-hidden" data-testid="calendar-feed">
      <p className="text-sm font-medium text-[#2C4A3E] flex items-center gap-2"><CalendarSync className="w-4 h-4" />Sync check-ins to my calendar</p>
      <p className="text-xs text-stone-600">Add this private link once. New, moved and cancelled check-ins update in your calendar automatically.</p>
      <div className="flex items-center gap-2 rounded-full bg-white border border-[#E6DEC3] pl-4 pr-1 py-1">
        <span className="text-xs text-stone-600 truncate flex-1 min-w-0" data-testid="calendar-feed-url">{f.url}</span>
        <button onClick={copy} data-testid="calendar-feed-copy" aria-label="Copy calendar link" className="p-2 rounded-full bg-[#2C4A3E] text-white"><Copy className="w-3.5 h-3.5" /></button>
      </div>
      <div className="flex flex-wrap gap-2">
        <a href={f.webcal} data-testid="calendar-feed-webcal" className={btn}>Open in Apple / Outlook</a>
        <button onClick={() => setSteps(!steps)} data-testid="calendar-feed-google-toggle" className={btn}>Google Calendar steps <ChevronDown className={`w-3.5 h-3.5 transition-transform ${steps ? "rotate-180" : ""}`} /></button>
        <button onClick={reset} data-testid="calendar-feed-reset" className={btn}><RefreshCw className="w-3.5 h-3.5" />Reset link</button>
      </div>
      {steps && (
        <ol className="list-decimal pl-5 text-xs text-stone-700 space-y-1" data-testid="calendar-feed-google-steps">
          <li>Tap the copy button above.</li>
          <li>On a computer, open <a href={GOOGLE_ADD} target="_blank" rel="noreferrer" className="underline" data-testid="calendar-feed-google-open">Google Calendar → Add calendar from URL</a>.</li>
          <li>Paste the link and click <b>Add calendar</b>. It will show on your phone too.</li>
        </ol>
      )}
      <p className="text-[11px] text-stone-500">Apple and Outlook usually refresh within an hour. Google can take up to a day, which is Google's own limit. Bell and phone alerts are always instant. Keep this link private, and tap Reset if it's ever shared.</p>
    </section>
  );
};
